<script lang="ts">
	import type { HTMLButtonAttributes } from "svelte/elements";

	const {
		kind,
		class: className,
		children,
		...props
	}: { kind: "plus" | "minus" | "custom" } & HTMLButtonAttributes = $props();
</script>

<button
	class={[
		className,
		"disabled:text-nov-dark-900/50 bg-white",
		"text-nov-dark-900 size-10 rounded-full border-nov-red-300 border-2",
		"flex items-center cursor-pointer justify-center relative",
	]}
	type="button"
	{...props}
>
	{#if kind === "custom"}
		{@render children?.()}
	{:else}
		<span class="w-3 h-0.5 bg-current"></span>
		{#if kind === "plus"}
			<span class="w-0.5 h-3 bg-current absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"></span>
		{/if}
	{/if}
</button>
